import { mapState } from "vuex";
export const vipIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    vipTopBarList() {
      // let isMaster = localStorage.userType == 101;
      let isMaster = this.shopInfo.isMaster;
      let topbarList = [
        {
          name: "会员管理",
          isActive: false,
          path: "/vip",
          icon:require("@/assets/img/menuIcons/icon-vip.png")
        },
        {
          name: "会员卡",
          isActive: false,
          path: "/vip/card",
          icon:require("@/assets/img/menuIcons/icon-vipcard.png")
        },
        {
          name: "积分记录",
          isActive: false,
          path: "/vip/consumeDetail",
          icon:require("@/assets/img/menuIcons/icon-vipconsumeDetail.png")
        },
        {
          name: "充值活动",
          isActive: false,
          path: "/vip/cardActivity",
          icon:require("@/assets/img/menuIcons/icon-vipcardActivity.png")
        },
        {
          name: "会员消费记录",
          isActive: false,
          path: "/vip/cardConsume",
          icon:require("@/assets/img/menuIcons/icon-vipcardConsume.png")
        },
        {
          name: "会员申请记录",
          isActive: false,
          path: "/vip/applyList",
          icon:require("@/assets/img/menuIcons/icon-vipapplyList.png")
        },
      ];
      if (!isMaster) {
        topbarList = [
          {
            name: "会员管理",
            isActive: false,
            path: "/vip",
            icon:require("@/assets/img/menuIcons/icon-vip.png")
          },
          {
            name: "积分记录",
            isActive: false,
            path: "/vip/consumeDetail",
            icon:require("@/assets/img/menuIcons/icon-vipconsumeDetail.png")
          },
          {
            name: "会员消费记录",
            isActive: false,
            path: "/vip/cardConsume",
            icon:require("@/assets/img/menuIcons/icon-vipcardConsume.png")
          },
        ];
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
